module.exports = __webpack_public_path__ + "static/img/qrcode1.205d0b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode1.png
// module id = nu74
// module chunks = 0